import React from 'react'
import classes from './AddLayout.module.scss'

export default function AddLayoutModal (props) {
  return (
    <div
      {...props}
      className={classes.modal}
    />
  )
}
